import { Redeem, Logout } from "@mui/icons-material";
import { List } from "@mui/material";
import { ReactElement } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { ACCESS_TOKEN, REFRESH_TOKEN } from "../../../constants";
import { useFeedback } from "../../../providers/feedback/feeedback";
import NavListItem from "../../main/components/nav_list_item";

interface MerchantDrawerOption {
  label: string;
  icon: ReactElement;
  route: string;
}

const options: MerchantDrawerOption[] = [
  { label: "Voucher Redemption", icon: <Redeem />, route: "/merchant" },
  { label: "Logout", icon: <Logout />, route: "/logout" },
];

export default function MerchantDrawer({
  horizontal = false,
  onItemClick,
}: {
  horizontal?: boolean;
  onItemClick?: () => void;
}) {
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const { showSnackbar } = useFeedback();

  const handleLogout = async () => {
    try {
      // await merchantLogout();
      sessionStorage.removeItem('merchant_data');
      localStorage.setItem(ACCESS_TOKEN, "");
      localStorage.setItem(REFRESH_TOKEN, "");
      sessionStorage.setItem(ACCESS_TOKEN, "");
      sessionStorage.setItem(REFRESH_TOKEN, "");
      showSnackbar("Logged out successfully");
      navigate("/");
    } catch (error) {
      console.error("Logout error:", error);
      showSnackbar("Logout failed");
    }
    onItemClick?.();
  };

  return (
    <List sx={{ p: 1, width: "100%" }}>
      {options.map((option) => (
        <NavListItem
          key={option.route}
          label={option.label}
          icon={option.icon}
          linkTo={option.route === "/logout" ? "" : option.route}
          active={pathname.includes(option.route)}
          horizontal={horizontal}
          onClick={option.route === "/logout" ? handleLogout : onItemClick}
        />
      ))}
    </List>
  );
}
